module.exports = __webpack_public_path__ + "img/judgesTitleImg.2fb35107.png";